import React, { Context } from 'react';
import Ability from '../interfaces/ability';

const { createContext, useContext } = React;

export type PartialAbility =
  | Partial<Ability>
  | ((params: any) => Partial<Ability>);

let AbilityContext: Context<PartialAbility> =
  createContext<PartialAbility>(null);

export const useAbility = (): PartialAbility => {
  return useContext<PartialAbility>(AbilityContext);
};

export const AbilityProvider = ({
  ability,
  children,
}: {
  ability: PartialAbility;
  children: any;
}) => <AbilityContext.Provider value={ability} children={children} />;
